import { useNavigate } from "react-router-dom";
import { AuthLayout, Button } from "@hiya/ui";
import infoSvg from "../../assets/icon-information.svg";

export function LockedPage() {
  const navigate = useNavigate();

  return (
    <AuthLayout
      title="Your account has been locked"
      icon={<img src={infoSvg} alt="" width={80} height={80} />}
      backTo="/login"
    >
      <div className="flex flex-col gap-8 items-center w-full">
        <p className="text-base font-medium leading-[1.2] text-text-secondary text-center">
          Too many failed attempts. Your account is temporarily locked. Please try again later.
        </p>
        <Button onClick={() => navigate("/login")}>
          Back to Log in
        </Button>
      </div>
    </AuthLayout>
  );
}
